<template>
  <div>
    <div class="modal" id="modal-notification" tabindex="-1" role="dialog">
      <div class="modal-dialog modal- modal-dialog-centered modal-" role="document">
        <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" id="modal-title-notification">Thông tin người dùng cập nhật</h6>
              <button type="button" class="close" @click="close_modal" data-dismiss="modal">
                  <span aria-hidden="true">×</span>
              </button>
            </div>
            <div v-if="counselor.temp_info != undefined && counselor.temp_info != {}" class="modal-body">
              <div>Tên:{{counselor.temp_info.name}}</div>
              <div>Địa chỉ: {{counselor.temp_info.address}}</div>
              <div>SĐT: {{counselor.temp_info.phone}}</div>
              <div>Ngày sinh: {{counselor.temp_info.date_of_birth}}</div>
              <div>Chức danh: {{counselor.temp_info.counselor_title}}</div>
              <div>Trình độ học vấn: {{counselor.temp_info.level_education}}</div>
              <div>Linkedin: {{counselor.temp_info.linkedin}}</div>              
              <div>Bằng cấp:
                <ul>
                  <li v-for="de in counselor.temp_info.degree">
                    <div>Tên trường: {{de.university}}</div>    
                    <div>Chuyên ngành: {{de.major}}</div>    
                    <div>Ngày bắt đầu: {{de.start_date}}</div>    
                    <div>Ngày kết thúc: {{de.end_date}}</div>    
                  </li>  
                </ul>                
              </div>

              <div>Kinh nghiệm:
                <ul>
                  <li v-for="de in counselor.temp_info.experience">
                    <div>Tên trường: {{de.company}}</div>    
                    <div>Chuyên ngành: {{de.major}}</div>    
                    <div>Ngày bắt đầu: {{de.start_date}}</div>    
                    <div>Ngày kết thúc: {{de.end_date}}</div>    
                  </li>  
                </ul>                
              </div>

              <div>Dịch vụ cung cấp:
                <ul>
                  <li v-for="service in counselor.temp_info.available_service">
                    <div>{{service.name}}</div>                   
                  </li>  
                </ul>                
              </div>   
              <div>Giới thiệu: {{counselor.temp_info.introduce}}</div>
              <div>Điểm chuẩn hóa:
                <div v-for="score in counselor.temp_info.score">
                  <div>{{score['name']}}: {{score['score']}}</div>
                </div>
              </div>
            </div>
            <div v-else> Không có thông tin cập nhật nào</div>
            <div class="modal-footer">
                <button type="button" class="btn btn-white" @click="close_modal">Đóng</button>
            </div>
        </div>
      </div>
  </div>
  </div>  

</template>
<script>
import {mapState} from 'vuex';
  export default{
    props: {
      show_modal_user_detail: {}
    },
    methods: {      
      close_modal: function () {
        this.show_modal_user_detail.show = false;
        this.$emit('close_modal', this.show_modal_user_detail)
      }
    },
    computed:{
      ...mapState('vuex_admin',{
        counselor(state){     
          var counselor_obj = {}          
          state.list_counselors.forEach((counselor)=>{
            
            if (counselor.id == this.show_modal_user_detail.id)
            {
              counselor_obj = counselor
              return counselor_obj
            }  
          })
          return counselor_obj

        }
      }
      )
    }
  };
</script>
<style lang="scss" scoped>
  #modal-notification.modal{
    display: unset;
    .modal-body{
      overflow: scroll;
      height: 400px;
    }        
  }
</style>


// WEBPACK FOOTER //
// src/views/components/Modal/DetailUserInfo.vue